"use client";
import { cn } from "@/lib/utils";
import { NotificationModel } from "@/types/notification";
import { useTranslations } from "next-intl";
import React, { Fragment, useState } from "react";
import { DropdownMenuItem } from "../ui/dropdown-menu";
import NotificationCard from "./notification-card";
import { Separator } from "../ui/separator";
import { PaginationModel } from "@/types/common";
import InfiniteScroll from "../ui/infinite-scroll";
import { getNotifications } from "@/services/notification.service";
import { Loader2 } from "lucide-react";
import { Link } from "@/i18n/navigation";

const NotificationsList = ({
  notifications,
}: {
  notifications: PaginationModel<NotificationModel>;
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [notificationsList, setNotificationsList] = useState<
    NotificationModel[]
  >(notifications.results);
  const t = useTranslations();
  const hasMore = page < notifications.last_page;

  const loadMore = async () => {
    setIsLoading(true);
    setPage((prev) => prev + 1);
    const newNotifications = await getNotifications(page + 1);
    setNotificationsList([...notificationsList, ...newNotifications.results]);
    setIsLoading(false);
  };

  return (
    <div className="overflow-y-auto h-[400px]">
      {notificationsList.length === 0 && (
        <div className="p-4 text-center text-sm text-muted-foreground">
          {t("noNotifications")}
        </div>
      )}

      {notificationsList.map((item) => (
        <Fragment key={item.id}>
          <Link
            scroll
            href={item.type === "order" ? `/orders/${item.data.model_id}` : ""}
          >
            <DropdownMenuItem className={cn(!item.is_read && "bg-muted/70")}>
              <NotificationCard notification={item} />
            </DropdownMenuItem>
            <Separator />
          </Link>
        </Fragment>
      ))}
      <InfiniteScroll
        isLoading={isLoading}
        hasMore={hasMore ?? false}
        next={loadMore}
        threshold={1}
      >
        {hasMore && <Loader2 className="my-4 mx-auto h-8 w-8 animate-spin" />}
      </InfiniteScroll>
    </div>
  );
};

export default NotificationsList;
